import React, { Component } from 'react';

import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';

import Util from '../Util';

/**
 * Generates times between the two given times (at half-hour intervals).
 */
function generateTimes(firstHour, isHalfPast, lastHour) {
  const times = [];
  let hours = firstHour;
  let mins = isHalfPast ? 30 : 0;
  while ((hours < lastHour) || (hours === lastHour && mins === 0)) { // startTimes go from 9:00AM - 5:00PM
    times.push(Util.toDisplay(hours, mins));
    // increment by half an hour
    if (mins === 0) {
      mins = 30;
    } else {
      mins = 0;
      hours++;
    }
  }
  return times;
}

const startTimes = generateTimes(9, false, 17);

class CustomTimePicker extends Component {

  constructor(props) {
    super(props);

    this.state = {
      dialogOpen: false,
      endTimes: [],

      startTime: null,
      endTime: null
    };

    this.setDialogOpen = this.setDialogOpen.bind(this);
    this.handleStartTimeChange = this.handleStartTimeChange.bind(this);
    this.handleEndTimeChange = this.handleEndTimeChange.bind(this);
    this.lockInTimes = this.lockInTimes.bind(this);
  }

  setDialogOpen(open) {
    let startTime = null;
    let endTime = null;
    // read existing startTime and endTime, if any
    if (this.props.details.time && this.props.details.time.indexOf(' to ') !== -1) {
      const splitted = this.props.details.time.split(' to ');
      startTime = splitted[0];
      endTime = splitted[1];
    }
    this.setState({
      dialogOpen: open,
      startTime: startTime,
      endTime: endTime
    });
  }

  handleStartTimeChange(evt, idx, val) {
    // update endTimes options
    const sel = Util.toHoursMinutes(val);

    this.setState({
      startTime: val,
      endTime: '',
      endTimes: generateTimes(sel.hours + 1, sel.mins === 30, 18)
    });
  }

  handleEndTimeChange(evt, idx, val) {
    this.setState({
      endTime: val
    });
  }

  // sets the time span in the parent component and closes the modal
  lockInTimes() {
    this.props.fieldChanged('time', this.state.startTime + ' to ' + this.state.endTime);
    this.setDialogOpen(false);
  }

  render() {
    const styles = {
      center: {
        textAlign: 'center',
        justifyContent: 'center'
      },
      textFieldStyle: {
        marginTop: -16,
        width: '100%',
        textAlign: 'center',
        justifyContent: 'center'
      },
      inputStyle: {
        width: '100%',
        textAlign: 'center',
        justifyContent: 'center'
      },
      hintStyle: {
        width: '100%',
        color: '#ccc',
        textAlign: 'center',
        justifyContent: 'center'
      },
      dropdown: {
        width: '100%',
        maxWidth: 400
      },
      fromTo: {
        fontWeight: 'bold',
        marginTop: 30,
        marginBottom: 0
      },
      dialogButton: {
        margin: 5
      }
    };
    const actions = [
      <RaisedButton
        label="Cancel"
        primary={false}
        onTouchTap={() => this.setDialogOpen(false)}
        style={styles.dialogButton}
      />,
      <RaisedButton
        label="Ok"
        primary={true}
        onTouchTap={this.lockInTimes}
        disabled={!this.state.startTime || !this.state.endTime}
        style={styles.dialogButton}
      />
    ];

    return (
      <div>
        <Dialog
          title="Booking Time"
          actions={actions}
          modal={false}
          open={this.state.dialogOpen}
          onRequestClose={this.closeDialog}
          bodyStyle={styles.center}
          titleStyle={styles.center}
          className="counteract-zoom"
        >
          <p>Please select when your car will be available to be washed:</p>
          <p style={styles.fromTo}>From</p>
          <DropDownMenu
            value={this.state.startTime}
            style={styles.dropdown}
            onChange={this.handleStartTimeChange}
            autoWidth={false}
          >
          {startTimes.map((startTime) => {
            return (
              <MenuItem key={startTime} value={startTime} primaryText={startTime} />
            );
          })}
          </DropDownMenu>
          <p style={styles.fromTo}>To</p>
          <DropDownMenu
            disabled={this.state.startTime === null}
            value={this.state.endTime}
            style={styles.dropdown}
            onChange={this.handleEndTimeChange}
            autoWidth={false}
          >
          {this.state.endTimes.map((endTime) => {
            return (
              <MenuItem key={endTime} value={endTime} primaryText={endTime} />
            );
          })}
          </DropDownMenu>
        </Dialog>

        <TextField
          style={styles.textFieldStyle}
          hintStyle={styles.hintStyle}
          inputStyle={styles.inputStyle}
          hintText="Select Times"
          floatingLabelText={this.props.floatingLabelText}
          floatingLabelFixed={true}
          maxLength={128}
          value={this.props.details.time}
          onClick={() => this.setDialogOpen(true)}
          onChange={() => this.setDialogOpen(true)}
          onFocus={() => this.setDialogOpen(true)}
        />
      </div>
    );
  }
}

export default CustomTimePicker;



// WEBPACK FOOTER //
// ./src/components/CustomTimePicker.js